import { render, staticRenderFns } from "./NewSubcontract.vue?vue&type=template&id=55a3141d&scoped=true&"
import script from "./NewSubcontract.vue?vue&type=script&lang=js&"
export * from "./NewSubcontract.vue?vue&type=script&lang=js&"
import style0 from "./NewSubcontract.vue?vue&type=style&index=0&id=55a3141d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a3141d",
  null
  
)

export default component.exports